module.exports = __webpack_public_path__ + "img/zoom-pegasus-turbo-2-mens-running-shoe-GcDSX3.8a76ac52.png";